<template>
<div class="formGroup" :data-layout="layout">
  <div class="formGroup__body">
    <formLabel :label="label" :validation="validation" :required="isRequired"></formLabel>
    <div class="radioGroup" :class="design">
      <label
        class="radio"
        v-for="option in options"
        :key="option.value"
        :data-error="errors.has(name)"
      >
        <input
          v-validate="validation"
          :name="name"
          type="radio"
          class="radio__input"
          :value="option.value"
          :checked="checked === option.value"
          @change="update($event)"
        >
        <span class="radio__description"><span>{{ option.text }}</span></span>
      </label>
    </div>
  </div>
  <div class="formGroup__footer">
    <slot></slot>
    <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
  </div>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-radio',
  mixins: [mixin],
  props: {
    options: { type: Array, required: true },
    design: { type: String, default: 'radio' }, // 'radio' or 'button'
    defaultNoCheck: { type: Boolean, default: false },
    isRequired: {type: Boolean, default: false}
  },
  computed: {
    checked() {
      return !this.value && !this.defaultNoCheck ? this.options[0].value : this.value
    }
  },
  update($event) {
    const value = $event.target.value
    this.$emit('input', value)
    this.$emit('change', value)
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormRadio.vue